import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    borderRadius: '50%',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 500,
    padding: '2px 4px',
    '--designated-color': 'var(--color-error-tooltip)',
    border: '1px solid',
    borderColor: 'var(--designated-color)',
    color: 'var(--designated-color)',
    fontSize: '0.75rem',
  },
}));

const ErrorCount = ({ value = 0 }) => {
  const classes = useStyles();

  if (!value) {
    return <></>;
  }

  return <div className={classes.root}>{value}</div>;
};

export default ErrorCount;
